import { render, staticRenderFns } from "./resultView.vue?vue&type=template&id=6dd82ffe&scoped=true&"
import script from "./resultView.vue?vue&type=script&lang=js&"
export * from "./resultView.vue?vue&type=script&lang=js&"
import style0 from "./resultView.vue?vue&type=style&index=0&id=6dd82ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd82ffe",
  null
  
)

export default component.exports